import React from 'react';
import { btnTranslate, trainingsTranslate } from '../../../../i18n/translatedMessages';
import { IdeaIcon } from '../../../../Icons/Icons';
import * as RB from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { levelSkills } from './levelSkills';
import { BsTrash } from 'react-icons/bs';
import { AiOutlineSend } from 'react-icons/ai';

const SkillsAcordion = ({ dataLanguages, dataSkills, handleChange, handleRemove, handleSend }) => {
  const radioData = levelSkills;

  return (
    <>
      <RB.Accordion defaultActiveKey="0" className="py-3">
        <RB.Accordion.Item eventKey="0">
          <RB.Accordion.Header className="bg-training-header-nulinga">
            <IdeaIcon size={35} color="#f4f4f4" />
            {trainingsTranslate.englishTestTitle}
          </RB.Accordion.Header>
          <RB.Accordion.Body>
            <div className="row align-items-center">
              <div className="col-4 p-4">
                <img alt="..." className="img-fluid" src="https://nulinga.com/static/marketing/landings/images/pt_BR/nulinga-logo-violeta.svg" />
              </div>
              <div className="col-8">
                <p className="card-text">{trainingsTranslate.nulingaText}</p>
              </div>
            </div>
            <div className="row d-flex justify-content-center mt-2">
              <div className="col-6 text-center">
                <a className="btn training-btn-blue rounded-pill text-light" href="https://nulinga.com/postulantes/new?token=x3w" target="_blank" rel="noreferrer">
                  {btnTranslate.performTest}
                </a>
              </div>
              <div className="col-6 text-center">
                <button className="btn btn-secondary rounded-pill text-light">{btnTranslate.showResult}</button>
              </div>
            </div>
          </RB.Accordion.Body>
        </RB.Accordion.Item>
        {dataLanguages?.length > 0 &&
          dataLanguages?.map((language, index) => {
            return (
                <RB.Accordion.Item key={language?.language + index} className="mt-3" eventKey={index+1}>
                  <RB.Accordion.Header>
                    <IdeaIcon size={35} color="#f4f4f4" />
                    {language?.language}
                  </RB.Accordion.Header>
                  <RB.Accordion.Body>
                    <div className="row align-items-center justify-content-center">
                      <div className="col-12">
                        <Form>
                          <div key={`inline-radio`} className="d-flex justify-content-evenly mb-3">
                            {radioData?.languajes?.map((el, i) => (
                              <Form.Check key={i} inline label={el?.textEs} type="radio" id={`inline-radio-${i}`} value={i + 1} onChange={(e) => handleChange(index, e.target.value, 'language')} checked={i + 1 === language?.language_level_id} />
                            ))}
                          </div>
                        </Form>
                        <div className="d-flex justify-content-end">
                          <button
                            className="btnAddReference btn rounded-pill px-3 py-2"
                            style={{
                              pointer: 'cursor',
                            }}
                            onClick={() => handleSend(true)}
                          >
                            <h5 className="m-0">
                              <AiOutlineSend
                                style={{
                                  color: '#822ed3',
                                }}
                                size={25}
                              />
                            </h5>
                          </button>
                          <button
                            className="btnAddReference btn rounded-pill px-3 py-2"
                            style={{
                              pointer: 'cursor',
                            }}
                            onClick={() => handleRemove('language', index)}
                          >
                            <h5 className="m-0">
                              <BsTrash
                                style={{
                                  color: '#822ed3',
                                }}
                                size={25}
                              />
                            </h5>
                          </button>
                        </div>
                      </div>
                    </div>
                  </RB.Accordion.Body>
                </RB.Accordion.Item>
            );
          })}

        {dataSkills?.length > 0 &&
          dataSkills?.map((skills, index) => {
            return (
                <RB.Accordion.Item key={skills?.name + index} className="mt-3" eventKey={dataLanguages?.length+index+1}>
                  <RB.Accordion.Header>
                    <IdeaIcon size={35} color="#f4f4f4" />
                    {skills?.name}
                  </RB.Accordion.Header>
                  <RB.Accordion.Body>
                    <div className="row align-items-center justify-content-center">
                      <div className="col-12">
                        <Form>
                          <div key={`inline-radio`} className="d-flex justify-content-evenly mb-3">
                            {radioData?.skills?.map((el, i) => (
                              <Form.Check key={i} inline label={el?.textEs} type="radio" id={`inline-radio-${i}`} value={i + 1} onChange={(e) => handleChange(index, e.target.value, 'skills')} checked={i + 1 === skills?.skill_level_id} />
                            ))}
                          </div>
                        </Form>
                        <div className="d-flex justify-content-end">
                          <button
                            className="btnAddReference btn rounded-pill px-3 py-2"
                            style={{
                              pointer: 'cursor',
                            }}
                            onClick={() => handleSend(true)}
                          >
                            <h5 className="m-0">
                              <AiOutlineSend
                                style={{
                                  color: '#822ed3',
                                }}
                                size={25}
                              />
                            </h5>
                          </button>
                          <button
                            className="btnAddReference btn rounded-pill px-3 py-2"
                            style={{
                              pointer: 'cursor',
                            }}
                            onClick={() => handleRemove('skill', index)}
                          >
                            <h5 className="m-0">
                              <BsTrash
                                style={{
                                  color: '#822ed3',
                                }}
                                size={25}
                              />
                            </h5>
                          </button>
                        </div>
                      </div>
                    </div>
                  </RB.Accordion.Body>
                </RB.Accordion.Item>
            );
          })}
      </RB.Accordion>
    </>
  );
};

export default SkillsAcordion;
